/**
 * Returns the base name of a file by removing any trailing numbers in parentheses. The replace() call removes any trailing numbers in parentheses
 */
export function getFileBaseName(name: string) {
  return name.replace(/\s*\(\d+\)\s*/g, '');
}
